<div class="dropdown">
  <button
    class="btn font-size-12 button-btn dropdown-toggle mat-button-wrapper"
    style="padding: 3px"
    type="button"
    id="dropdownMenuButton"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
  >
    Print NOC Letter
  </button>
  <div
    class="dropdown-menu"
    aria-labelledby="dropdownMenuButton"
    style="max-height: 95px; overflow: auto"
  >
    <a
      class="dropdown-item"
      *ngFor="let x of dropdownLanguages"
      (click)="getNocNames(x.Id)"
      >{{ x.Template_Name }}</a
    >
  </div>
</div>

<div
  class="modal fade in"
  id="NOCmodel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="
    background-color: rgba(0, 0, 0, 0.5);
    text-align: initial;
    overflow: auto;
  "
>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <button
          type="button"
          class="btn font-size-12 button-btn"
          mat-raised-button
          color="primary"
          [class.spinner]="loading"
          (click)="printLetter()"
        >
          print NOC Letter
        </button>
        <button
          type="button"
          class="close btn font-size-12 button-btn"
          (click)="OnClose()"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body" id="pdfNOCDownload">
        <div class="row mb-0" style="font-size: 10px">
          <div class="col-md-12 ck-content">
            <div [innerHtml]="content"></div>
          </div>
        </div>
      </div>
      <div id="LODPrint" style="display: none">
        <table class="MsoTableGrid" width="1000px" border="1" cellspacing="0" cellpadding="0">
          <thead>
            <tr>
              <!--<th class="WD-66">Document Type</th>-->
              <th class="WD-66">Document Title</th>
              <th class="WD-66">In Favour Of</th>
              <th class="WD-66">Date Of Executation</th>
              <th class="WD-66">Executation By</th>
              <th class="WD-66">No Of Pages</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of LODDataDetail; let i = index">
              <!--<td>{{ data.DocType }}</td>-->
              <td>{{ data.DocTitle }}</td>
              <td>{{ data.Remark }}</td>
              <td>{{ data.DateOfExecution }}</td>
              <td>{{ data.ExecutedBy }}</td>
              <td>{{ data.No_Of_Pages }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


<div
  class="modal fade"
  id="NOCNameSelectModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="NOCNameSelectLabel"
  style="background-color: rgba(0, 0, 0, 0.5)"
>
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header">
        <h6 class="modal-title" id="NOCNameSelectLabel">
          Select NOC Names
        </h6>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeNOCNameSelectLabel()"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <label>
            <input
              type="checkbox"
              [(ngModel)]="SelectAll"
              (change)="toggleSelectAll()"
              
            />
            Select All
          </label>
        </div>
        <div *ngFor="let Name of resNames">
          <label>
            <input type="checkbox" [(ngModel)]="Name.selected"
            (change)="checkIfAllSelected()" />
            {{ Name.Name }}
          </label>
        </div>
      </div>
      <div class="col-md-10">
          Browse Doc:<i
            class="fa fa-upload ml-2"
            (click)="docUFile.click()"
            aria-hidden="true"
          ></i>
          <ng-container *ngIf="docModal.DocumentImages.length > 0">
            <div *ngFor="let doc of docModal.DocumentImages; let i = index">
              <i class="fa fa-file-pdf mr-2" aria-hidden="true"></i
              >{{ doc.DocFileName }}
              <i
                class="fa fa-times ml-2"
                aria-hidden="true"
                style="cursor: pointer"
                (click)="removeDFile(i)"
              ></i>
            </div>
          </ng-container>
          <input
            #docUFile
            type="file"
            [multiple]="true"
            accept="application/pdf,application/vnd.ms-excel,image/jpeg, image/png"
            (change)="fileChangeListenerD(docUFile.files, docUFile)"
            style="display: none"
          />
        </div>
      <div class="modal-footer">
        <button
          class="btn font-size-12 button-btn"
          (click)="Get_Template(SelectedId)"

        >
          Show NOC Letter
        </button>
      </div>
    </div>
  </div>
</div>

